/**
 * Cliente Supabase — singleton pra browser.
 *
 * Usa @supabase/ssr (cookies em vez de localStorage por padrão) — funciona
 * tanto no SSR quanto no client, sem hydration issues.
 */
import { createBrowserClient } from "@supabase/ssr";
import type { SupabaseClient } from "@supabase/supabase-js";

let cached: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (cached) return cached;
  cached = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
  return cached;
}
